import { Select } from "@msuite/ui/form";
import { getProtocolTypeIcon, Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { moment } from "@msuite/utils/date";
import { getProtocolTypeColor, getProtocolTypeTranslationKey } from "@msuite/utils/protocols";
import { type ProtocolFormSchema, protocolTypes } from "@msuite/utils/schemas";
import { generateId } from "@msuite/utils/strings";
import type { ProtocolType } from "@msuite/utils/types";
import { useFormContext } from "react-hook-form";
import { templates } from "./constants";

export function ProtocolFormTypeMenu() {
	/** Hooks */
	const { t } = useTranslation();

	/** Context */
	const methods = useFormContext<ProtocolFormSchema>();

	/** Functions */
	function handleOnLoadTypeTemplate(type: ProtocolType) {
		methods.trigger();
		const contentIsDirty = methods.getFieldState("content").isDirty;
		if (contentIsDirty) {
			return;
		}
		const template = templates[type];
		methods.setValue(
			"content",
			template.map((item) => ({ ...item, id: generateId() })),
		);

		switch (type) {
			case "call-request":
				break;
			case "meeting":
				methods.setValue("startTime", moment().startOf("hour").getTime("HH:mm"));
				methods.setValue("endTime", moment().startOf("hour").add(1.5, "hour").getTime("HH:mm"));
				break;
			case "general":
				break;
			case "negotiation":
				break;
		}
	}

	/** Render */
	return (
		<div className="w-[400px]">
			<Select
				itemNotFoundLabel="Not found"
				control={methods.control}
				name="type"
				isRequired
				isNullable={false}
				label={t("protocols.type")}
				options={protocolTypes.map((template) => ({
					label: template,
					value: template,
					item: {
						template,
					},
					cyId: `protocol-type-${template}`,
				}))}
				onChange={(_value) => {
					const value = _value as ProtocolType;
					if (!protocolTypes.includes(value)) return;
					methods.setValue("callRequestDetails", {});
					handleOnLoadTypeTemplate(value);
				}}
				renderOption={(option) => (
					<div className="h-stack">
						<Icon
							name={getProtocolTypeIcon(option.template)}
							color={`var(--color-${getProtocolTypeColor(option.template)}-500)`}
						/>
						<p>{t(getProtocolTypeTranslationKey(option.template))}</p>
					</div>
				)}
				data-cy="protocol-type-select"
			/>
		</div>
	);
}
